module.exports = __webpack_public_path__ + "img/TechStablesHorsemanship_ua.4b83ea81.webp";